import { Badge } from '@shopify/polaris';

type Tone = 'success' | 'warning' | 'critical' | 'info' | 'attention' | undefined;

const TONE_MAP: Record<string, Tone> = {
  delivered: 'success',
  success: 'success',
  ok: 'success',
  pending: 'attention',
  in_transit: 'info',
  picked_up: 'info',
  out_for_delivery: 'info',
  failed: 'critical',
  error: 'critical',
  exception: 'critical',
  attempted_delivery: 'warning',
  cancelled: 'warning',
};

export interface StatusBadgeProps {
  status: string;
}

export function StatusBadge({ status }: StatusBadgeProps): JSX.Element {
  const key = status.toLowerCase();
  const tone = TONE_MAP[key];
  return <Badge tone={tone}>{status}</Badge>;
}
